export const fetchCurrency = {
  CNY: '￥',
  USD: '$',
  EUR: '€',
  INR: '₹',
  VND: '₫'
}

export const MessageStatus = {
  Undefined: 0,
  Unread: 1,
  Read: 2
}

export const MessageCategory = {
  Personal: 0,
  Event: 1,
  System: 2
}

// For log web visit
export const VisitType = {
  Visit: 'Visit',
  Deposit: 'Deposit',
  Withdraw: 'Withdraw',
  PlayGame: 'PlayGame'
}

/***
 * 获取指定国家版本支持的货币种类
 * @type {{getCurrency: (function(*): string[])}}
 * 2022-02-17 CHP 创建
 */
export const InternationCurrency = {
  getCurrency: function (internation) {
    let currency = ['INR ₹']
    switch (internation) {
      case 'INT':
        currency = ['INR ₹']
        break
      case 'IN':
        currency = ['INR ₹']
        break
      case 'VN':
        currency = ['VND ₫']
        break
    }
    return currency
  }
}

/****
 * 获取指定国家版本的可提款范围
 * @type {{getRange: WithdrawAmountRange.getRange}}
 * 2022-02-17 CHP 创建
 */
export const InternationWithdrawAmountRange = {
  getRange: function (internation) {
    let range = [
      [
        100, 500, 1000, 2000
      ],
      [
        5000, 10000, 30000, 50000
      ]
    ]

    switch (internation) {
      case 'INT':
        range = [
          [
            100, 500, 1000, 2000
          ],
          [
            5000, 10000, 30000, 50000
          ]
        ]
        break
      case 'IN':
        range = [
          [
            100, 500, 1000, 2000
          ],
          [
            5000, 10000, 30000, 50000
          ]
        ]
        break
      case 'VN':
        range = [
          [
            50000, 100000, 300000
          ],
          [
            500000, 1000000, 3000000
          ]
        ]
        break
    }
    return range
  }
}

/****
 * 获取指定国家的银行列表
 * @type {{getBankList: InternationBankList.getBankList}}
 * 2022-02-17 CHP 创建
 */
export const InternationBankList = {
  getBankList: function (internation) {
    let bankList = []
    switch (internation) {
      case 'VN':
        bankList = [
          {
            code: 'AGR',
            name: 'AGRIBANK'
          },
          {
            code: 'BIDV',
            name: 'BIDV BANK'
          },
          {
            code: 'EIB',
            name: 'EXIMBANK'
          },
          {
            code: 'GPB',
            name: 'GP BANK'
          },
          {
            code: 'HDB',
            name: 'HD BANK'
          },
          {
            code: 'MB',
            name: 'MBBANK'
          },
          {
            code: 'NAB',
            name: 'NAMA BANK'
          },
          {
            code: 'ACB',
            name: 'NGAN HANG A CHAU'
          },
          {
            code: 'VAB',
            name: 'VAB BANK'
          },
          {
            code: 'OJB',
            name: 'OCEANBANK'
          },
          {
            code: 'PGB',
            name: 'PGBANK'
          },
          {
            code: 'OCB',
            name: 'PHUONGDONG BANK'
          },
          {
            code: 'STB',
            name: 'SACOMBANK'
          },
          {
            code: 'SGB',
            name: 'SAIGONBANK'
          },
          {
            code: 'SCB',
            name: 'SCB'
          },
          {
            code: 'SHB',
            name: 'SHB BANK'
          },
          {
            code: 'TCB',
            name: 'TECHCOMBANK'
          },
          {
            code: 'TPB',
            name: 'TIENPHONG BANK'
          },
          {
            code: 'VIB',
            name: 'VIB BANK'
          },
          {
            code: 'VCB',
            name: 'VIETCOMBANK'
          },
          {
            code: 'CTG',
            name: 'VIETINBANK'
          },
          {
            code: 'VPB',
            name: 'VPBANK'
          },
          {
            code: 'ABB-K',
            name: 'ABBANK'
          },
          {
            code: 'Dong',
            name: 'DongABank'
          }
        ]
        break
    }
    return bankList
  }
}

/****
 * 获取指定国家的IFSC验证表达式
 * @type {{getReg: InternationIFSCReg.getReg}}
 */
export const InternationIFSCReg = {
  getReg: function (internation) {
    let reg = RegExp(/^[A-Za-z]{4}[0]\w{6}$/)
    switch (internation) {
      case 'IN':
        reg = RegExp(/^[A-Za-z]{4}[0]\w{6}$/)
        break
      case 'INT':
        reg = RegExp(/^[A-Za-z]{4}[0]\w{6}$/)
        break
      case 'VN':
        reg = RegExp(/[\w-]+$/)
        break
    }
    return reg
  }
}

/***
 * 获取指定国家的银行账号正则表达式
 * @type {{getReg: (function(*): RegExp)}}
 */
export const InternationAccountNumberReg = {
  getReg: function (internation) {
    let reg = RegExp(/^\d{8,18}$/)
    switch (internation) {
      case 'IN':
        reg = RegExp(/^\d{8,18}$/)
        break
      case 'INT':
        reg = RegExp(/^\d{8,18}$/)
        break
      case 'VN':
        reg = RegExp(/^\d{8,18}$/)
        break
    }
    return reg
  }
}

/***
 * 获取指定国家的身份证正则表达式
 * @type {{getReg: (function(*): RegExp)}}
 */
export const InternationIDCardReg = {
  getReg: function (internation) {
    let reg = RegExp(/^\d{12}$/)
    switch (internation) {
      case 'IN':
        reg = RegExp(/^\d{12}$/)
        break
      case 'INT':
        reg = RegExp(/^\d{12}$/)
        break
      case 'VN':
        reg = RegExp(/^(\d{9}|\d{12})$/)
        break
    }
    return reg
  }
}



// WEBPACK FOOTER //
// ./src/constant.js